import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, NavigationSkipped, NavigationStart, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { MenuService } from '../menu-service/menu.service';
import { Menu } from '../menu-service/menu-models';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
@UntilDestroy()

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.css']
})
export class SideNavComponent implements OnInit, OnDestroy {
  isNavClosed = false;
  user: any;
  menus: any;
  selectedMenu: any;
  // isSubMenu = false;
  isShowSmallScreenMenu = false;
  selectedMenukey: any;
  isRouterEventsExist = false;


  constructor(
    private sharedDataService: SharedDataService,
    private menuService: MenuService,
    public sanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.router.events
    .pipe(untilDestroyed(this)).subscribe((event) => {
      this.isRouterEventsExist = true;
      if (event instanceof NavigationEnd || event instanceof NavigationSkipped) {
        if (event.url) {
          this.selectMenuDynamically(event.url);
        }
      }
    });
    this.getUser();
    this.getSubMenus();
    this.getSmallScreenMenuState();
    this.getUrlOnPageReload();
  }

  getUrlOnPageReload() {
    if (this.isRouterEventsExist) return;
    if(this.router.url) {
      this.selectMenuDynamically(this.router.url);
    }
  }

  selectMenuDynamically(routeUrl: string) {
    routeUrl = routeUrl.replace(/#.*/, '');
    const url = routeUrl.split("/");
    if (url[1] === "") {
      this.selectedMenu = "signups";
    } else {
      this.selectedMenu = url[1];
    }
    this.onSelectMenu(this.menus ? this.menus[this.selectedMenu] : null);
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(untilDestroyed(this)).subscribe(user => {
        if (user) {
          this.user = user;
          this.menus = this.menuService.getMenu(user);
      
          Object.keys(this.menus).forEach(key => {
            this.menus[key].sanitizedIcon = this.sanitizer.bypassSecurityTrustHtml(this.menus[key].icon);
          });
        }
      });
  }

  sortMethod(a: any, b: any) {
    return a.value.position > b.value.position ? 1 : -1;
  }

  onSelectMenu(menu: any) {
    this.selectedMenu = menu;
    this.sharedDataService.saveSubMenus(menu ? menu : null);
  }

  getSubMenus() {
    this.sharedDataService
      .getSubMenus()
      .pipe(untilDestroyed(this)).subscribe((menu: any) => {
        if (menu && this.selectedMenu) {
          if (this.selectedMenu.key !== menu.key) {
            this.selectedMenu = menu;
          }
        }
      });
  }

  onSelectMenuSmallScreen(menu: any) {
    this.selectedMenu = menu;
    this.sharedDataService.saveSubMenus(menu ? menu : null);
    if (this.selectedMenukey === menu.key) {
      this.selectedMenukey = '';
    } else {
      this.selectedMenukey = menu.key;
    }
    this.sharedDataService.setSmallScreenMenuState(false);
  }

  getSmallScreenMenuState() {
    this.sharedDataService
      .getSmallScreenMenuState()
      .pipe(untilDestroyed(this)).subscribe(data => {
        this.isShowSmallScreenMenu = data;
      });
  }

  closeSmallScreenMenu() {
    this.sharedDataService.setSmallScreenMenuState(false);
  }

  setMenuCss(evt: any) {
    return 'bg-nav-light text-nav-light';
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    if (location.href) {
      let currentUrl = location.href.replace('http://','');
      currentUrl = currentUrl.replace('https://','');
      const url = currentUrl.split("/");
      if (url[1] === "dashboard" || url[1] === "") {
        this.selectedMenu = "dashboard";
      } else {
        this.selectedMenu = url[1];
      }
      this.onSelectMenu(this.menus ? this.menus[this.selectedMenu] : null);
    }
  }

  getMenu(menu: any) {
    return menu;
  }

  toggleNav() {
      this.sharedDataService.setSmallScreenMenuState(false);
  }

  ngOnDestroy(): void {
  }
}
